import React from 'react';
import './Footer.css';
import { useContent } from '../../hooks/customHooks';

export default function Footer({ className }) {
    const { content } = useContent();
    const {
        image,
        image_url,
        image_2,
        image_2_url,
        faqs,
        content: footerContent,
        copyright,
    } = content?.global_settings?.footer || {};

    function isValidUrl(url) {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }

    if (!image && !image_2 && !faqs && !footerContent && !copyright) return null;

    return (
        <section className={`footer-section ${className}`}>
            <footer id="site-footer">
                {image &&
                    (isValidUrl(image_url) ? (
                        <a
                            href={image_url}
                            aria-label="Footer logo"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={image} alt="Footer logo" />
                        </a>
                    ) : (
                        <img src={image} alt="Footer logo" />
                    ))}

                {image_2 &&
                    (isValidUrl(image_2_url) ? (
                        <a
                            href={image_2_url}
                            aria-label="Footer logo"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={image_2} alt="Footer logo" />
                        </a>
                    ) : (
                        <img src={image_2} alt="Footer logo" />
                    ))}
                {faqs && <p className="faqs-text" dangerouslySetInnerHTML={{ __html: faqs }} />}
                {footerContent && <p dangerouslySetInnerHTML={{ __html: footerContent }} />}
                {copyright && (
                    <b className="copyright" dangerouslySetInnerHTML={{ __html: copyright }} />
                )}
            </footer>
        </section>
    );
}
